import { mutatorAction } from 'satcheljs';
import { getItem } from 'owa-local-storage';
import getMyOutlookViewState from '../store/myOutlookViewState';
import type { MyOutlookTab } from '../store/myOutlookViewState';
import type { ReengagementOpenEmailCta } from 'owa-personal-os-types';
import { getStoredScheduleVisible } from '../utils/scheduleVisibilityStorage';

export function isMyOutlookFullPageShowing(): boolean {
    return getMyOutlookViewState().isFullPageShowing;
}

export function getReadingPaneInitialTab(): MyOutlookTab {
    return getMyOutlookViewState().initialTab;
}

const SECTION_HIDDEN_KEY = 'owa-personal-os-section-hidden';
let sectionHiddenHydrated = false;

const hydrateSectionHiddenMutator: () => void = mutatorAction(
    'hydrateSectionHiddenMutator',
    (): void => {
        try {
            if (getItem(self, SECTION_HIDDEN_KEY) === 'true') {
                getMyOutlookViewState().isSectionHidden = true;
            }
        } catch {
            // localStorage unavailable
        }
    }
);

export function isMyOutlookSectionHidden(): boolean {
    if (!sectionHiddenHydrated) {
        sectionHiddenHydrated = true;
        hydrateSectionHiddenMutator();
    }
    return getMyOutlookViewState().isSectionHidden;
}

let scheduleVisibleHydrated = false;

const hydrateScheduleVisibleMutator: () => void = mutatorAction(
    'hydrateScheduleVisibleMutator',
    (): void => {
        try {
            getMyOutlookViewState().isScheduleVisible = getStoredScheduleVisible();
        } catch {
            // localStorage unavailable
        }
    }
);

export function getIsScheduleVisible(): boolean {
    // Hydrate the user's last explicit show/hide preference on first read so
    // the page reopens in their last known state rather than always collapsed.
    if (!scheduleVisibleHydrated) {
        scheduleVisibleHydrated = true;
        hydrateScheduleVisibleMutator();
    }
    return getMyOutlookViewState().isScheduleVisible;
}

export function getHighlightedActionableItemIds(): string[] {
    return getMyOutlookViewState().highlightedActionableItemIds;
}

const clearPendingReengagementActionMutator: () => void = mutatorAction(
    'clearPendingReengagementActionMutator',
    (): void => {
        getMyOutlookViewState().pendingReengagementAction = null;
    }
);

/** Reads and clears the pending re-engagement email handoff. */
export function consumePendingReengagementAction(): ReengagementOpenEmailCta | null {
    const pending = getMyOutlookViewState().pendingReengagementAction;
    if (pending) {
        clearPendingReengagementActionMutator();
    }
    return pending;
}
